module.exports = __webpack_public_path__ + "static/img/4.21e9b24.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/4.jpg
// module id = dGPU
// module chunks = 1